import {ChevronDownIcon, ChevronUpIcon} from '@chakra-ui/icons';
import {Box, HStack, Text, VStack} from '@chakra-ui/layout';
import {Button, Collapse} from '@chakra-ui/react';
import {ReactNode} from 'react';

/**
 * Header de section qu'on voit au-dessus de chaque groupe de produits (par catégorie)
 * partagé entre cadencier, listes, opérations commerciales et produits par saison.
 * Affiche un titre, un badge count et un bouton collapse.
 */
export const SectionHeader: React.FC<{
  title: string;
  count: number;
  id?: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
}> = ({title, count, id, isOpen, onToggle, children}) => {
  return (
    <VStack
      alignItems='stretch'
      width='100%'
      py='12px'
      px='0'
      id={id}
    >
      <HStack
        bg='gray.light_bg'
        py='6px'
        px='12px'
        mx='12px'
        borderRadius='8px'
        height='41px'
      >
        <Text
          fontWeight='600'
          fontSize='sm'
        >
          {title}
        </Text>
        <Box
          textColor='blue.text'
          fontWeight='600'
          fontSize='xs'
          bg='white'
          p='1'
          borderRadius='8px'
          minW='2em'
          aspectRatio={1}
          textAlign='center'
        >
          {count}
        </Box>
        <Button
          variant='ghost'
          p='0'
          ml='auto'
          onClick={onToggle}
        >
          {!isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Button>
      </HStack>
      <Collapse in={!isOpen}>{children}</Collapse>
    </VStack>
  );
};
